<template>
  <div>
    <div
      class="modal animated fadeIn"
      id="dailyexpensesModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold">Daily expenses</small>
              </legend>
              <form @submit.prevent="loadDailyExpenses()">
                <div class="row">
                  <input type="hidden" class="accounttype_id" :value="Accounttype.id" />
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Expenses date</label>
                      <input
                        type="date"
                        class="form-control dailysales_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button type="button" class="btn btn-danger btn-flat" data-dismiss="modal">
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button type="submit" class="btn btn-primary btn-flat creatingDailyExpenses">
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingDailyExpensesLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal animated fadeIn"
      id="fullexpensesModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold">Daily expenses</small>
              </legend>
              <form @submit.prevent="loadFullExpenses()">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Expenses date</label>
                      <input
                        type="date"
                        class="form-control fulldaily_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button type="button" class="btn btn-danger btn-flat" data-dismiss="modal">
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button type="submit" class="btn btn-primary btn-flat creatingFullExpenses">
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingFullExpensesLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold">manage account types</small>
      </legend>
      <button
        type="button"
        class="btn btn-success"
        data-toggle="modal"
        data-target="#fullexpensesModal"
      >
        <i class="fa fa-file-pdf-o"></i> Daily expenses
      </button>
      <p></p>
      <div></div>
      <div class="accounttypesLoader">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <i class="fa fa-spinner fa-spin" style="font-size:24px; color: blue"></i>loading accounttypes...
      </div>
      <vue-good-table
        :columns="columns"
        :rows="systemAccounttypes"
        :fixed-header="true"
        :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'Action'">
            <button
              type="button"
              class="btn btn-primary btn-roundec"
              data-toggle="modal"
              data-target="#dailyexpensesModal"
              @click="viewAccounttype(props.row.id)"
            >
              <i class="fa fa-file-pdf-o"></i> Daily expenses
            </button>
          </span>
        </template>
      </vue-good-table>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Account code",
          field: "account_code",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by accounttype code"
          }
        },
        {
          label: "Account name",
          field: "account_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by account name"
          }
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          type: "text"
        }
      ]
    };
  },
  created() {
    this.loadAccounttypes();
  },
  computed: {
    ...mapGetters(["systemAccounttypes", "Accounttype"])
  },
  methods: {
    ...mapActions(["loadAccounttypes", "loadDailyExpenses", "viewAccounttype", "loadFullExpenses"])
  }
};
</script>
<style scoped>
.creatingDailyExpensesLoader {
  display: none;
}
.creatingFullExpensesLoader{
  display: none;
}

</style>


// WEBPACK FOOTER //
// src/reports/dailyexpenses.vue